var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgMinusOutline = function SvgMinusOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 13H5a1 1 0 100 2h18a1 1 0 100-2z",
    fill: "#023F80"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIzIDEzSDE1SDVDNC40NDc3MiAxMyA0IDEzLjQ0NzcgNCAxNEM0IDE0LjU1MjMgNC40NDc3MiAxNSA1IDE1SDE1SDIzQzIzLjU1MjMgMTUgMjQgMTQuNTUyMyAyNCAxNEMyNCAxMy40NDc3IDIzLjU1MjMgMTMgMjMgMTNaIiBmaWxsPSIjMDIzRjgwIi8+Cjwvc3ZnPgo=";
export { SvgMinusOutline as ReactComponent };